export default "__VITE_ASSET__4450318d__"